//export const enAPI = 'http://localhost:3001/repost/admin/';
export const enAPI = `https://p69qtd03yk.execute-api.us-east-1.amazonaws.com/repost/admin/`;
export const app_client_id = "42tenb9mk62rfaqttgqqr3bnm3";
export const app_web_domain_name =
  "sony-doorkeeper.auth.us-east-1.amazoncognito.com";
